import React, { useState, useEffect  } from "react";


import { useParams } from "react-router-dom";
import "./Dhenkanal360page.css";

export default function Dhenkanal360page() {
  const { officeId } = useParams();

  const [officeData, setOfficeData] = useState({
    officeName: "",
    officerName: "",
    block: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    aadhaar: "",
    panchayat: "",
    cleanliness: "",
    purpose: "",
    interaction: "",
    overall: "",
    overallFeedbackText: "",
    infoFound: "",
    infoReason: "",
    improvement: "",
  });

  // -----------------------------------------
  // ✅ GET: Fetch office details
  // -----------------------------------------
  useEffect(() => {
    fetch(`https://d360-backend.vercel.app/api/offices/${officeId}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("API Error: " + res.status);
        }
        return res.json();
      })
      .then((data) => {
        const office = data.data || data;

        setOfficeData({
          officeName: office.officeName,
          officerName: office.officerName,
          block: office.block,
        });
      })
      // .catch((err) => console.error("Error fetching office details:", err));
  }, [officeId]);

  const dhenkanal360pageHandleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // -----------------------------------------
  // ✅ POST: Submit Feedback Form
  // -----------------------------------------
  const dhenkanal360pageHandleSubmit = (e) => {
    e.preventDefault();

    // Map form data to backend API field names
    const payload = {
      officeId: parseInt(officeId), // Ensure it's a number
      name: formData.name,
      mobileNumber: formData.mobile, // ✅ FIXED: backend expects mobileNumber
      aadhaarNumber: formData.aadhaar, // ✅ FIXED: backend expects aadhaarNumber
      gramPanchayat: formData.panchayat, // ✅ FIXED: backend expects gramPanchayat
      cleanlinessRating: formData.cleanliness, // ✅ FIXED: backend expects cleanlinessRating
      purposeOfVisit: formData.purpose, // ✅ FIXED: backend expects purposeOfVisit
      personInteractedWith: formData.interaction, // ✅ FIXED: backend expects personInteractedWith
      overallSatisfaction: formData.overall, // ✅ FIXED: backend expects overallSatisfaction
      overallSatisfactionReason: formData.overallFeedbackText, // ✅ FIXED: backend expects overallSatisfactionReason
      infoFoundEasily: formData.infoFound === "Yes", // ✅ FIXED: backend expects boolean
      infoReason: formData.infoReason,
      improvementSuggestions: formData.improvement, // ✅ FIXED: backend expects improvementSuggestions
    };

    fetch("https://d360-backend.vercel.app/api/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || "Failed to submit feedback");
        }
        return res.json();
      })
      .then((data) => {
        alert("Thank you! Your feedback has been submitted successfully.");
        // console.log("Feedback saved:", data);
      })
      .catch((err) => {
        // console.error("Feedback submission error:", err);
        alert("Submission failed! Please try again.");
      });
  };
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="dhenkanal360page-container">

      {/* HEADER */}
      <div className="dhenkanal360page-header">
        <h2>DHENKANAL 360</h2>
        <p>FEEDBACK FORM</p>
      </div>

      {/* TOP INFORMATION BLOCK */}
      <div className="dhenkanal360page-top-info">
        <div>
          <strong>Office Name:</strong>
          <p>{officeData.officeName || "Loading..."}</p>
        </div>

       
      </div>

      {/* FORM */}
      <form
        className="dhenkanal360page-form-card"
        onSubmit={dhenkanal360pageHandleSubmit}
      >
        <label>1. Name :</label>
        <input type="text" name="name" onChange={dhenkanal360pageHandleChange} />

        <label>2. Mobile Number :</label>
        <input type="text" name="mobile" onChange={dhenkanal360pageHandleChange} />

        <label>3. Aadhaar Number :</label>
        <input type="text" name="aadhaar" onChange={dhenkanal360pageHandleChange} />

        <label>4. Gram Panchayat :</label>
        <input type="text" name="panchayat" onChange={dhenkanal360pageHandleChange} />

        {/* CLEANLINESS */}
        <label>5. How did you find the cleanliness of our office Premises?</label>
        <div className="dhenkanal360page-radio-group">
          <label>
            <input 
              type="radio" 
              name="cleanliness" 
              value="Satisfied" 
              onChange={dhenkanal360pageHandleChange} // ✅ FIXED: now updates state
              className="checkbox-margin" 
            />
            Satisfied
          </label>

          <label>
            <input 
              type="radio" 
              name="cleanliness" 
              value="Needs Improvement" 
              onChange={dhenkanal360pageHandleChange} // ✅ FIXED: now updates state
              className="checkboxmargin" 
            />
            <span className="cleanliness-text">Needs Improvement</span>
          </label>
        </div>

        <label>6. What was the purpose of your visit?</label>
        <textarea name="purpose" placeholder="Write here..." onChange={dhenkanal360pageHandleChange} />

        <label>7. Whom did you interact with during your visit?</label>
        <textarea name="interaction" placeholder="Write here..." onChange={dhenkanal360pageHandleChange} />

     {/* OVERALL SERVICE */}
<label>8. How satisfied were you with the overall services?</label>

<div className="dhenkanal360page-radio-group">
  <label>
    <input 
      type="radio" 
      name="overall" 
      value="Good" 
      onChange={dhenkanal360pageHandleChange}
      className="checkbox-margin" 
    /> 
    Good
  </label>

  <label>
    <input 
      type="radio" 
      name="overall" 
      value="Average" 
      onChange={dhenkanal360pageHandleChange}
      className="checkbox-margin" 
    /> 
    Average
  </label>

  <label>
    <input 
      type="radio" 
      name="overall" 
      value="Needs Improvement" 
      onChange={dhenkanal360pageHandleChange}
      className="checkboxmargin" 
    />
    <span className="cleanliness-text">Needs Improvement</span>
  </label>
</div>

{/* SHOW TEXTAREA ONLY WHEN USER SELECTS "Needs Improvement" */}
{formData.overall === "Needs Improvement" && (
  <textarea
    name="overallFeedbackText"
    placeholder="Write here..."
    onChange={dhenkanal360pageHandleChange}
  />
)}

        <label>9. Did you find the information you needed easily?</label>
        <div className="dhenkanal360page-radio-group">
          <label>
            <input
              type="radio"
              name="infoFound"
              value="Yes"
              onChange={dhenkanal360pageHandleChange} // ✅ FIXED: now uses standard handler
            />
            Yes
          </label>

          <label>
            <input
              type="radio"
              name="infoFound"
              value="No"
              onChange={dhenkanal360pageHandleChange} // ✅ FIXED: now uses standard handler
            />
            No
          </label>
        </div>

        {/* REASON WHEN "NO" SELECTED */}
        {formData.infoFound === "No" && (
          <>
            <label>Reason:</label>
            <textarea
              name="infoReason"
              placeholder="Write here..."
              onChange={dhenkanal360pageHandleChange}
            />
          </>
        )}

        <label>10. What improvements would you suggest for better service?</label>
        <textarea
          name="improvement"
          placeholder="Write here..."
          onChange={dhenkanal360pageHandleChange}
        />

        <button className="dhenkanal360page-submit-btn" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}

